// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import { normalizeLast4SSN } from 'utils/normalizeLast4SSN';
import MaskedInput from 'react-text-mask';

export const RawLast4SSNMaskInput = (props) => {
  const { name, ...otherInputProps } = props;
  return (
    <MaskedInput
      name={name}
      id={name}
      type="text"
      placeholder="XXX-XX-____"
      mask={['X', 'X', 'X', '-', 'X', 'X', '-', /\d/, /\d/, /\d/, /\d/]}
      {...otherInputProps}
    />
  );
};

RawLast4SSNMaskInput.propTypes = {
  name: PropTypes.string.isRequired,
};

/**
 * NB: The `normalize` function passed to Field strips the input
 * value of non-numeric characters so a "clean" value is
 * stored in redux, rather than the "masked" value.
 */
export const Last4SSNMaskInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawLast4SSNMaskInput),
  { normalize: normalizeLast4SSN }
);

export const RawLast4SSNMaskField =
  wrapFormComponentWithLabelAndError(RawLast4SSNMaskInput);

/**
 * NB: The `normalize` function passed to Field strips the input
 * value of non-numeric characters so a "clean" value is
 * stored in redux, rather than the "masked" value.
 */
const Last4SSNMaskField = connectFormComponentToReduxForm(
  RawLast4SSNMaskField,
  {
    normalize: normalizeLast4SSN,
  }
);
Last4SSNMaskField.displayName = 'Last4SSNMaskField';

export default Last4SSNMaskField;
